<template>
  <v-container style="min-height: calc(100vh - 80px);" class="my-5">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <v-row>
          <v-col cols="12" md="12">
            <v-tabs centered>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'Detailclass', query: { berita: check.berita } }"
                exact>
                <v-icon left>mdi-text-box-check-outline</v-icon> Pengumuman
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'Detailclasswork', query: { berita: check.berita } }"
                exact>
                <v-icon left>mdi-folder-text</v-icon> Tugas
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'Detailclasspeople', query: { berita: check.berita } }"
                exact>
                <v-icon left>mdi-calendar-month</v-icon> Anggota
              </v-tab>
              <v-tab
                v-if="false"
                class="text-capitalize"
                :to="{ name: 'Detailclassgrade', query: { berita: check.berita } }"
                exact>
                <v-icon left>mdi-calendar-month</v-icon> Nilai
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="12" md="12" v-if="alertdata.show">
            <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
          </v-col>
          <v-col cols="12" md="12" v-if="loading.detail" class="text-center">
            <v-progress-circular
              :width="3"
              color="red"
              indeterminate>
            </v-progress-circular>
          </v-col>
          <v-col cols="12" md="10" offset-md="1">
            <v-card
              flat
              v-if="!loading.detail && detaildata.length > 0">
              <v-card-text>
                <v-row class="black--text">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-card
                          flat>
                          <v-app-bar
                            flat>
                            <v-toolbar-title class="font-weight-bold">
                              Teachers
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="primary"
                              icon
                              exact>
                              <v-icon>mdi-account-plus</v-icon>
                            </v-btn>
                          </v-app-bar>
                          <v-card-text>
                            <v-expansion-panels flat>
                              <v-expansion-panel
                                v-for="(teach, i) in teacherlist"
                                :key="i">
                                <v-expansion-panel-header hide-actions>
                                  <span>
                                    <v-icon left>mdi-account</v-icon> {{ teach.user_firstname }} {{ teach.user_lastname }}
                                  </span>
                                  <v-spacer></v-spacer>
                                  <span class="text-right">
                                    <v-menu
                                      offset-y
                                      bottom
                                      left
                                      nudge-bottom="10"
                                      transition="scale-transition">
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          color="primary"
                                          class="text-capitalize"
                                          icon
                                          v-bind="attrs"
                                          v-on="on"
                                          exact>
                                          <v-icon>mdi-dots-vertical</v-icon>
                                        </v-btn>
                                      </template>
                                      <v-list>
                                        <v-list-item>
                                          <v-list-item-title>Remove</v-list-item-title>
                                        </v-list-item>
                                      </v-list>
                                    </v-menu>
                                  </span>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </v-card-text>
                        </v-card>
                        <v-card
                          flat>
                          <v-app-bar
                            flat>
                            <v-toolbar-title class="font-weight-bold">
                              Students
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="primary"
                              icon
                              exact>
                              <v-icon>mdi-account-plus</v-icon>
                            </v-btn>
                          </v-app-bar>
                          <v-card-text>
                            <v-expansion-panels flat>
                              <v-expansion-panel
                                v-for="(student, i) in studentlist"
                                :key="i">
                                <v-expansion-panel-header hide-actions>
                                  <span>
                                    <v-icon left>mdi-account</v-icon> {{ student.user_firstname }} {{ student.user_lastname }}
                                  </span>
                                  <v-spacer></v-spacer>
                                  <span class="text-right">
                                    <v-menu
                                      offset-y
                                      bottom
                                      left
                                      nudge-bottom="10"
                                      transition="scale-transition">
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          color="primary"
                                          class="text-capitalize"
                                          icon
                                          v-bind="attrs"
                                          v-on="on"
                                          exact>
                                          <v-icon>mdi-dots-vertical</v-icon>
                                        </v-btn>
                                      </template>
                                      <v-list>
                                        <v-list-item>
                                          <v-list-item-title>Remove</v-list-item-title>
                                        </v-list-item>
                                      </v-list>
                                    </v-menu>
                                  </span>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="12">
                    <div class="mt-5 text-center">
                      <v-btn
                        class="mr-2 mb-2"
                        fab
                        depressed
                        dark
                        x-small
                        :to="{ name: 'Listclass' }">
                        <v-icon dark>
                          mdi-arrow-left-thick
                        </v-icon>
                      </v-btn>
                      <span class="title">Daftar kelas</span>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Detailclasspeople',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      detail: false,
      teacher: false,
      student: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    detaildata: [],
    teacherlist: [],
    studentlist: [],
    panduan: null,
    paramberita: {
      search: '',
      limit: '',
      offset: '',
    },
    check: {
      berita: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
  }),
  watch: {
    '$route.query.berita'(val) {
      if (val) {
        this.check.berita = val;
        this.getBerita();
      }
    },
  },
  mounted() {
    if (this.$route.query.berita && this.$route.query.berita !== '') {
      this.check.berita = this.$route.query.berita;
      this.getBerita();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  methods: {
    getBerita() {
      this.loading.detail = true;
      this.alertdata.show = false;
      if (this.check.berita) {
        this.axios
          .get(
            this.api + '/api/kelas/teacher/' + this.check.berita,
            {
              params: this.paramberita,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.detaildata = resdata.data;
                this.getTeacher();
                this.getStudent();
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.detail = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.detail = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.loading.detail = false;
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Berita tidak ditemukan!';
      }
    },
    getTeacher() {
      if (this.tokenscr) {
        this.loading.teacher = true;
        this.axios
          .get(
            this.api + '/api/teacher/kelas/' + this.check.berita,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              console.log(resdata);
              if (resdata.error === false) {
                this.teacherlist = resdata.data;
              }
            }
            this.loading.teacher = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.teacher = false;
          });
      }
    },
    getStudent() {
      if (this.tokenscr) {
        this.loading.student = true;
        this.axios
          .get(
            this.api + '/api/student/kelas/' + this.check.berita,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              console.log(resdata);
              if (resdata.error === false) {
                this.studentlist = resdata.data;
              }
            }
            this.loading.student = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.student = false;
          });
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
